import { render } from "./PracticeSingleView.vue?vue&type=template&id=129a15cc&scoped=true&ts=true"
import script from "./PracticeSingleView.vue?vue&type=script&lang=ts"
export * from "./PracticeSingleView.vue?vue&type=script&lang=ts"

import "./PracticeSingleView.vue?vue&type=style&index=0&id=129a15cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129a15cc"]])

export default __exports__